import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { COLORS } from '../Constants/styles';

const NotFound: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: '80vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        px: 3,
        backgroundColor: COLORS.greyBG,
      }}
    >
      <Typography
        variant="h1"
        sx={{ fontSize: { xs: '6rem', md: '10rem' }, color: COLORS.accentDarkGreen, lineHeight: 1 }}
      >
        404
      </Typography>
      <Typography variant="h3" sx={{ mt: 2, mb: 1, color: COLORS.pureBlack }}>
        Page Not Found
      </Typography>
      <Typography variant="body1" sx={{ mb: 4, color: COLORS.accentBlackTransparent, maxWidth: 480 }}>
        The page you're looking for doesn't exist or has been moved.
      </Typography>
      <Button
        component={Link}
        to="/"
        variant="contained"
        sx={{
          bgcolor: COLORS.accentDarkGreen,
          color: COLORS.accentLime,
          fontFamily: "'Big Shoulders Text', sans-serif",
          fontWeight: 600,
          textTransform: 'uppercase',
          px: 4,
          py: 1.5,
          '&:hover': { bgcolor: COLORS.accentLime, color: COLORS.accentDarkGreen },
        }}
      >
        Back to Home
      </Button>
    </Box>
  );
};

export default NotFound;
